import { render, staticRenderFns } from "./menuTemplateActions.vue?vue&type=template&id=24810af3"
import script from "./menuTemplateActions.vue?vue&type=script&lang=js"
export * from "./menuTemplateActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports